import { EditOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Col, Flex, Row, Space, Spin, Typography } from "antd";
import Header from "../Header";

import { gold } from "@ant-design/colors";
import Footer from "components/footer";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ServiceApi from "../../../apis/ServiceApi";
import { showNotification } from "../../../common";
import InfoCertOrg from "../components/info-cert-org/InfoCertOrg";
import InfoCertPersion from "../components/info-cert-persion/InfoCertPersion";
import Prefixs from "common/Prefixs";
import InfoCertPersonOz from "pages/renewcert/components/info-cert-persion/InfoCertPersonOz";
import { OBJECT_COMPENSATION } from "constants/objectCompensation";
import { WarningOutlined } from "@ant-design/icons";
import WarningTextStepStart from "../components/warning-text/WarningTextStepStart";

const ReNewCertInfo = () => {
  const { Text } = Typography;

  const history = useHistory();
  const [dataInfoCert, setDataInfoCert] = useState({});
  const [loading, setLoading] = useState(false);
  const [dataCheckReq, setDataCheckReq] = useState({});
  const [loadingPage, setLoadingPage] = useState(false);
  const [statusYc, setStatusYc] = useState(0);

  const fetchDataCert = async () => {
    setLoadingPage(true);
    try {
      const res = await ServiceApi.getCertInfoCapBu();
      if (res && res.status === 200 && res.data.data) {
        setDataInfoCert(res.data.data.data);
        return res.data.data.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    fetchDataCert().then((value) => {
      fetchDataDetail(value);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchDataDetail = async (dataCert) => {
    setLoadingPage(true);
    try {
      const resCheck = await ServiceApi.checkrequestcapbu();

      if (resCheck.data.status === 200) {
        if (resCheck.data.data?.status) {
          const dataDetail = resCheck.data.data;
          setDataCheckReq(dataDetail);
          const statusCheck = dataDetail.status;
          setStatusYc(statusCheck);
          if (
            [
              OBJECT_COMPENSATION.WAIT,
              OBJECT_COMPENSATION.PENDING_APPROVAL,
              OBJECT_COMPENSATION.REJECT_APPROVAL,
              OBJECT_COMPENSATION.WAIT_SIGN,
            ].includes(statusCheck)
          ) {
            if (dataDetail.object === 4) {
              clickChangeInfo();
              return;
            }
            if (dataDetail.object === 2) {
              if (statusCheck === OBJECT_COMPENSATION.WAIT) {
                clickExtendNormal();
                return;
              }
              clickExtend(dataCert);
            }
          }
        }
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoadingPage(false);
    }
  };

  const clickExtendNormal = () => {
    history.push(`${Prefixs.RENEWCERT}`);
  };

  const clickExtend = (dataCert) => {
    history.push(`${Prefixs.COMPENSATION_EXTEND}?type=${dataCert?.type}`);
  };

  const renderWebByTypeOld = (isOld) => {
    if (dataInfoCert.type === 1) {
      return <InfoCertOrg isOld={isOld} oldInfo={dataInfoCert} />;
    } else if (dataInfoCert.type === 2) {
      return <InfoCertPersion isOld={isOld} oldInfo={dataInfoCert} />;
    } else if (dataInfoCert.type === 3) {
      return <InfoCertPersonOz isOld={isOld} oldInfo={dataInfoCert} />;
    }
  };

  const clickChangeInfo = () => {
    history.push(`${Prefixs.SUPPORT_CHANGE_INFO}?isCompensation2025=1`);
  };

  const approveCapBu = async () => {
    setLoading(true);
    try {
      const res = await ServiceApi.createrequestcapbu({});
      if (res.data.status !== 200) {
        showNotification("error", res.data.message, "");
      } else {
        history.push(Prefixs.RENEWCERT);
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin
      spinning={loading}
      tip="Vui lòng đợi..."
      indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
    >
      <div className="lock-certificate-container">
        <Header />
        <div className="w-full">
          <Flex justify="center" className="w-full">
            <Space direction="vertical" align="center">
              <div>
                <Typography.Title level={4}>
                  <>CẤP BÙ CHỨNG THƯ SỐ FASTCA USB TOKEN</>
                </Typography.Title>
              </div>
              <Typography.Text className="text-center">
                Quý khách hàng xác nhận thông tin chứng thư số thực hiện cấp bù
                như sau:
              </Typography.Text>
            </Space>
          </Flex>

          <Flex justify="center" className="w-full mt-3" gap={"large"}>
            <div className="w-full">{renderWebByTypeOld(true)}</div>
            <div className="w-full">{renderWebByTypeOld(false)}</div>
          </Flex>

          <div className="mt-5">
            <WarningTextStepStart/>
          </div>
          <Row justify={"center"} className="w-full">
            <Space>
              <Button type="primary" onClick={() => approveCapBu()}>
                Xác nhận
              </Button>
            </Space>
          </Row>
          <Flex justify={"center"} className="w-full">
            <div className="font-lg">
              Quý khách hàng cần
              <Typography.Text strong className="font-lg">
                {" "}
                ĐIỀU CHỈNH THÔNG TIN{" "}
              </Typography.Text>{" "}
              “chứng thư số sau cấp bù” vui lòng thực hiện
              <Link
                to={`${Prefixs.SUPPORT_CHANGE_INFO}?isCompensation2025=1`}
                component={Typography.Link}
                strong
                className="font-lg"
              >
                {" "}
                Tại đây.
              </Link>
            </div>
          </Flex>
        </div>
        <Footer></Footer>
      </div>
    </Spin>
  );
};
export default ReNewCertInfo;
